export function getLanguage(): string {
  const _window = window as any
  let language = 'en'
  if (_window.testLanguge) {
    language = _window.testLanguge
  }
  if (_window.wixEmbedsAPI) {
    language = _window.wixEmbedsAPI.getLanguage() || 'en'
  } else if (
    _window.wixTagManager &&
    typeof _window.wixTagManager.getConfig === 'function'
  ) {
    language = _window.wixTagManager.getConfig().language || 'en'
  }
  return language
}
